import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import useRequiredFields from "../../../../../hooks/useRequiredFields";
import FormValidation from "../../../../Common/FormValidation";
import Http from "../../../../Common/Http";
import ReactDropdown from "../../../../Common/ReactDropdown";


const Edit = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  const [region, setRegion] = useState({});
  const [area, setArea] = useState({});
  const [error, setError] = useState({});
  const { checkRequiredFields } = useRequiredFields();
  const [loading, setLoading] = useState(false);

  const [selectedRegionOption, setSelectedRegionOption] = useState(null);

  // Area Load Region Change Wise
  // const areaRegionWise = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;

  //   Http.get("/region-wise-area/" + value).then((res) => {
  //     setArea(res.data);
  //   });

  //   setInputs((values) => ({ ...values, [name]: value }));
  // };

  // const fetchData = () => {
  //   Http.get("/base/" + id + "/edit").then((res) => {
  //     setInputs({
  //       work_place_region_id: res.data.work_place_region_id,
  //       work_place_area_id: res.data.work_place_area_id,
  //       name: res.data.name,
  //       started_from: res.data.started_from,
  //       status: res.data.status,
  //       remarks: res.data.remarks,
  //     });

  //     setSelectedRegionOption({
  //       label: res.data.region.name,
  //       value: res.data.region.id,
  //     });

  //     // Deafault Area Data Load
  //     Http.get("/region-wise-area/" + res.data.work_place_region_id).then((res) => {
  //       setArea(res.data);
  //     });
  //   });

  //   Http.get("/regionSelect2").then((res) => {
  //     setRegion(res.data);
  //   });
  // };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [baseRes, regionRes] = await Promise.all([Http.get("/base/" + id + "/edit"), Http.get("/regionSelect2")]);

      setInputs({
        work_place_region_id: baseRes.data.work_place_region_id,
        work_place_area_id: baseRes.data.work_place_area_id,
        name: baseRes.data.name,
        started_from: baseRes.data.started_from,
        status: baseRes.data.status,
        remarks: baseRes.data.remarks,
      });

      setSelectedRegionOption({
        label: baseRes.data.region.name,
        value: baseRes.data.region.id,
      });

      // Deafault Area Data Load
      Http.get("/region-wise-area/" + baseRes.data.work_place_region_id).then((res) => {
        setArea(res.data);
      });

      setRegion(regionRes.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const selectHandleChange = (selectedOption, actionMeta) => {
    setSelectedRegionOption({
      label: selectedOption.label,
      value: selectedOption.value,
    });

    const name = actionMeta.name;
    const value = selectedOption.value;
    setInputs((values) => ({ ...values, [name]: value }));

    Http.get("/region-wise-area/" + value).then((res) => {
      setArea(res.data);
    });
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    if (checkRequiredFields()) {
      Http.put("/base/" + id, inputs)
        .then((res) => {
          navigate("/base", {
            state: { message: res.data.message, type: res.data.type },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    }
  };
  const reactDropdownHandler = (field, prop) => (e) => {
    const selectedValue = prop ? e.value[prop] : e.value;
  
    // Set the selected dropdown value for the specified field
    setInputs((values) => ({
      ...values,
      [field]: selectedValue,
    }));
  
    // Make the API call using the selected value
    Http.get("/region-wise-area/" + selectedValue)
      .then((res) => {
        setArea(res.data);
      })
      .catch((error) => {
        console.error("Error fetching area data:", error);
      });
  };

  const findSelectedOption = (options = [], value, key) => {
    return Array.isArray(options) ? options.find((item) => item[key] === value) : null;
  };
  
  const handleFetchRegionWiseArea = async (options, selectedValue, key) => {
    const selectedOption = findSelectedOption(options, selectedValue, key);
  
    if (selectedOption) {
      setLoading(true); // Start loading state
      try {
        const response = await Http.get("/region-wise-area/" + selectedOption[key]);
        setArea(response.data);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false); // End loading state
      }
    } else {
      console.error("Selected option not found.");
    }
  };
  
  
  const status = [
    { statusName: "Active", statusValue: "active" },
    { statusName: "Inactive", statusValue: "inactive" },
  ];


  return (
    <div>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Base</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            {error && Object.keys(error).length > 0 && (
              <div className="row">
                <div className="col-lg">
                  <FormValidation error={error} />
                </div>
              </div>
            )}

            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label htmlFor="">
                      Select Region <i className="fa fa-star required"></i>
                    </label>
                    {/* <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={selectedRegionOption}
                      value={selectedRegionOption}
                      onChange={selectHandleChange}
                      name="work_place_region_id"
                      options={region}
                    /> */}
                    <ReactDropdown
                      options={region}
                      optitle={"label"}
                      val={inputs.work_place_region_id}
                      onChange={reactDropdownHandler("work_place_region_id")}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Select Area <i className="fa fa-star required"></i>
                    </label>
                    {/* <select className="form-control" name="work_place_area_id" onChange={handleChange} data-required>
                      <option value="">Select Area</option>
                      {Array.from(area).map((item) => (
                        <option key={item.id} value={item.id} selected={inputs.work_place_area_id === item.id ? true : false}>
                          {item.name}
                        </option>
                      ))}
                    </select> */}
                    <ReactDropdown
                      options={area.length > 0 ? area : []}
                      optitle={"name"}
                      val={findSelectedOption(area, inputs.work_place_area_id, 'id') }
                      onChange={reactDropdownHandler("work_place_area_id", "id")}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Input Name"
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="started_from"
                      value={inputs.started_from || ""}
                      onChange={handleChange}
                      data-required
                    />
                  </div>

                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label htmlFor="">Status</label>
                    {/* <select className="form-control" name="status" onChange={handleChange}>
                      <option value="active" selected={inputs.status === "active" ? true : false}>
                        Active
                      </option>
                      <option value="inactive" selected={inputs.status === "inactive" ? true : false}>
                        inactive
                      </option>
                    </select> */}
                    <ReactDropdown
                      options={status}
                      optitle={"statusName"}
                      val={findSelectedOption(status, inputs.status, 'statusValue')}
                      onChange={reactDropdownHandler("status", "statusValue")}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label htmlFor="">Remarks</label>
                    <textarea
                      className="form-control"
                      name="remarks"
                      onChange={handleChange}
                      placeholder="Remarks"
                      value={inputs.remarks || ""}
                    ></textarea>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button className="btn btn-primary btn-block mg-b-10" onClick={formSubmit}>
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Edit;
